import React from "react";

const Office = () => {
  return (
    <section id="office" className="relative font-body">
      <div className="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
        <div className="lg:w-2/3 md:w-1/2 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
          <iframe
            width="100%"
            height="100%"
            title="map"
            className="absolute inset-0"
            frameBorder={0}
            marginHeight={0}
            marginWidth={0}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13239.23533409557!2d-83.38403106902292!3d33.94604459015731!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f66cfefe1188bb%3A0x8dc7c8bdb67d8975!2s200%20D.%20W.%20Brooks%20Drive%2C%20Athens%2C%20GA%2030602!5e0!3m2!1sen!2sus!4v1654266646646!5m2!1sen!2sus"
          />
          {/* <div className="bg-secondary-900 relative flex flex-wrap py-6 rounded shadow-md">
            <div className="px-6">
              <h2 className="font-title font-semibold text-white tracking-widest text-xs">
                ADDRESS
              </h2>
              <p className="mt-1 text-gray-400">
                200 D.W. Brooks Drive,<br />
                Athens, GA 30602
              </p>
            </div>
          </div> */}
        </div>
        <div
          className="lg:w-1/3 md:w-1/2 flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
          <h2 className="sm:text-4xl text-3xl mb-1 font-medium font-title">
            Office
          </h2>
          <p className="leading-relaxed mb-5">
            My office is located in room 649-B in Boyd Graduate Research Center (attached to Science Library).
          </p>
          <div className="relative mb-4">
            Office hours: MF 9:30-11:30 am (or by appt.)
          </div>
        </div>
      </div>
    </section>
  );
}
export default Office;


// WEBPACK FOOTER //
// ./src/components/Office.jsx